export default __webpack_public_path__ + "static/Vulcain_LP2_Vulcainlogo_Square-bf56a79200aeb56c49c9e508a0e0150a.png";